import styled from 'styled-components'

export const Container = styled.div`
  & > div {
    margin-top: 72px;
  }
`
